const $ = require("jquery");

export default class {
  onCreate(input) {
    this.state = {
      map: new Map([
        ["left-background-name", "白色"],
        ["left-movable-name", "白色"],
        ["left-text-name", "黑色"],
        ["right-background-name", "白色"],
        ["right-text-name", "黑色"],

        ["left-background-hex", "#FFFFFF"],
        ["left-movable-hex", "#FFFFFF"],
        ["left-text-hex", "#000000"],
        ["right-background-hex", "#FFFFFF"],
        ["right-text-hex", "#000000"],

        ["left-background-rgb", "RGB(255,255,255)"],
        ["left-movable-rgb", "RGB(255,255,255)"],
        ["left-text-rgb", "RGB(0,0,0)"],
        ["right-background-rgb", "RGB(255,255,255)"],
        ["right-text-rgb", "RGB(0,0,0)"],

        ["left-background-cmyk", "CMYK(0,0,0,0)"],
        ["left-movable-cmyk", "CMYK(0,0,0,0)"],
        ["left-text-cmyk", "CMYK(100,100,100,100)"],
        ["right-background-cmyk", "CMYK(0,0,0,0)"],
        ["right-text-cmyk", "CMYK(100,100,100,100)"],

        ["left-movable-cursor", "default"],
        ["left-movable-top", 360],
        ["left-movable-left", 360],
        ["left-movable-width", 400],
        ["left-movable-height", 120],

        ["left-movable-border-style", "1px solid #d3d3d3"],

        ["C", 0],
        ["M", 0],
        ["Y", 0],
        ["K", 0],
        ["R", 255],
        ["G", 255],
        ["B", 255]
      ]),
      movableList: [
        { top: 180, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 250, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 320, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 390, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 460, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 530, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 600, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 670, left: 360, width: 400, height: 60, cursor: "default" }
      ],
      selectedRadioId: "left-background-radio",
      textPosition: "center",
      openTextDialog: false,
      leftMovableText: "江山如此多娇，引无数英雄竞折腰。",
      openSnackBarDialog: false,
      msg: "複製到剪貼板成功"
    };

    this.backup = {
      map: new Map([
        ["left-background-name", "白色"],
        ["left-movable-name", "白色"],
        ["left-text-name", "黑色"],
        ["right-background-name", "白色"],
        ["right-text-name", "黑色"],

        ["left-background-hex", "#FFFFFF"],
        ["left-movable-hex", "#FFFFFF"],
        ["left-text-hex", "#000000"],
        ["right-background-hex", "#FFFFFF"],
        ["right-text-hex", "#000000"],

        ["left-background-rgb", "RGB(255,255,255)"],
        ["left-movable-rgb", "RGB(255,255,255)"],
        ["left-text-rgb", "RGB(0,0,0)"],
        ["right-background-rgb", "RGB(255,255,255)"],
        ["right-text-rgb", "RGB(0,0,0)"],

        ["left-background-cmyk", "CMYK(0,0,0,0)"],
        ["left-movable-cmyk", "CMYK(0,0,0,0)"],
        ["left-text-cmyk", "CMYK(100,100,100,100)"],
        ["right-background-cmyk", "CMYK(0,0,0,0)"],
        ["right-text-cmyk", "CMYK(100,100,100,100)"],

        ["left-movable-cursor", "default"],
        ["left-movable-top", 180],
        ["left-movable-left", 360],
        ["left-movable-width", 400],
        ["left-movable-height", 60],

        ["left-movable-border-style", "1px solid #d3d3d3"],

        ["C", 0],
        ["M", 0],
        ["Y", 0],
        ["K", 0],
        ["R", 255],
        ["G", 255],
        ["B", 255]
      ]),
      movableList: [
        { top: 180, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 250, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 320, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 390, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 460, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 530, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 600, left: 360, width: 400, height: 60, cursor: "default" },
        { top: 670, left: 360, width: 400, height: 60, cursor: "default" }
      ],
      selectedRadioId: "left-background-radio",
      textPosition: "center",
      openTextDialog: false,
      leftMovableText: "江山如此多娇，引无数英雄竞折腰。"
    };
  }

  onMount(input) {
    const that = this;

    // handle layer selection
    const layerList = document.getElementsByClassName("layer");
    for (let index = 0; index < layerList.length; index++) {
      const element = layerList[index];
      element.onmousedown = chooseLayer;
    }

    function chooseLayer(e) {
      e = e || window.event;
      // e.preventDefault();

      that.state.selectedRadioId = e.currentTarget.childNodes[0].id; // left-background-radio
      const targetId = that.state.selectedRadioId.slice(0, -6); // left-background
      const cmykStr = that.state.map.get(targetId + "-cmyk");
      const cmyk = cmykStr.slice(5, cmykStr.length - 1).split(",");
      that.state.map.set("C", cmyk[0]);
      that.state.map.set("M", cmyk[1]);
      that.state.map.set("Y", cmyk[2]);
      that.state.map.set("K", cmyk[3]);

      const w3c = w3color(that.state.map.get(targetId + "-rgb"));
      const rgb = w3c.toRgb();
      that.state.map.set("R", rgb.r);
      that.state.map.set("G", rgb.g);
      that.state.map.set("B", rgb.b);

      that.setStateDirty("map");
    }



    // handle color selection
    const colorList = document.getElementsByClassName("color");
    for (let index = 0; index < colorList.length; index++) {
      const element = colorList[index];
      element.onmousedown = clickColor;
    }

    function clickColor(e) {
      e = e || window.event;
      e.preventDefault();

      // controllers
      const cmykStr = e.currentTarget.dataset["cmykText"];
      const cmyk = cmykStr.slice(5, cmykStr.length - 1).split(",");
      that.state.map.set("C", cmyk[0]);
      that.state.map.set("M", cmyk[1]);
      that.state.map.set("Y", cmyk[2]);
      that.state.map.set("K", cmyk[3]);

      const hexText = e.currentTarget.dataset["hexText"];
      const w3c = w3color(hexText);
      const rgb = w3c.toRgb();
      that.state.map.set("R", rgb.r);
      that.state.map.set("G", rgb.g);
      that.state.map.set("B", rgb.b);

      // layers
      const targetId = that.state.selectedRadioId.slice(0, -6);
      that.state.map.set(targetId + "-name", e.currentTarget.innerText);
      that.state.map.set(targetId + "-hex", hexText);
      that.state.map.set(targetId + "-rgb", w3c.toRgbString().toUpperCase());
      that.state.map.set(targetId + "-cmyk", cmykStr);

      that.setStateDirty("map");
    }



    // Make the DIV elements draggable and resizable:
    var movableElements = document.getElementsByClassName("left-movable");
    for (let index = 0; index < movableElements.length; index++) {
      const element = movableElements[index];
      if (element) {
        dragElement(element, index);
      }
    }

    function dragElement(elmnt, index) {

      elmnt.dataset.movableIndex = index;
      var item = that.state.movableList[index];

      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      var isDragging = false;
      var isResizing = false;
      var headerHeight = 30;

      elmnt.addEventListener("mouseover", function () {
        if (!isDragging && !isResizing) {
          elmnt.addEventListener("mousemove", moveMouse);
        }
      });

      elmnt.addEventListener("mouseout", function () {
        if (!isDragging && !isResizing) {
          elmnt.removeEventListener("mousemove", moveMouse);
          item.cursor = "default";
          that.setStateDirty("movableList");
        }
      });

      function moveMouse(e) {
        var rect = elmnt.getBoundingClientRect();
        var offsetY = e.clientY - rect.top;

        item = that.state.movableList[index];
        if (offsetY < headerHeight) {
          item.cursor = "grab";
        } else {
          item.cursor = "se-resize";
        }

        that.setStateDirty("movableList");
      };

      elmnt.addEventListener("mousedown", dragMouseDown);

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();

        var rect = elmnt.getBoundingClientRect();
        var offsetY = e.clientY - rect.top;

        pos3 = e.clientX;
        pos4 = e.clientY;

        isDragging = true;
        isResizing = false;

        document.addEventListener("mouseup", closeDragElement);

        if (offsetY < headerHeight) {
          document.addEventListener("mousemove", elementDrag);
        } else {
          document.addEventListener("mousemove", elementResize);
          isResizing = true;
        }
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();

        pos1 = e.clientX - pos3;
        pos2 = e.clientY - pos4;
        pos3 = e.clientX;
        pos4 = e.clientY;

        var newLeft = elmnt.offsetLeft + pos1;
        var newTop = elmnt.offsetTop + pos2;

        if (newLeft >= 0 && newTop >= 0) {
          elmnt.style.left = newLeft + "px";
          elmnt.style.top = newTop + "px";

          item = that.state.movableList[index];
          item.cursor = "grabbing";
          item.left = newLeft;
          item.top = newTop;

          that.setStateDirty("movableList");
        }
      }

      function elementResize(e) {
        e = e || window.event;
        e.preventDefault();

        pos1 = e.clientX - pos3;
        pos2 = e.clientY - pos4;
        pos3 = e.clientX;
        pos4 = e.clientY;

        var newWidth = Math.max(100, elmnt.offsetWidth + pos1);
        var newHeight = Math.max(50, elmnt.offsetHeight + pos2);

        elmnt.style.width = newWidth + "px";
        elmnt.style.height = newHeight + "px";

        item = that.state.movableList[index];
        item.cursor = "se-resize";
        item.width = newWidth;
        item.height = newHeight;

        that.setStateDirty("movableList");
      }

      function closeDragElement(e) {
        isDragging = false;
        isResizing = false;
        document.removeEventListener("mouseup", closeDragElement);
        document.removeEventListener("mousemove", elementDrag);
        document.removeEventListener("mousemove", elementResize);

        item = that.state.movableList[index];
        item.cursor = "default";
        that.setStateDirty("movableList");
      }
    }

  }

  updateColorByController(e) {
    e = e || window.event;
    e.preventDefault();

    const key = e.target.id.slice(8);
    this.state.map.set(key, e.target.value);

    if (["C", "M", "Y", "K"].includes(key)) {
      const k = this.state.map.get("K");

      const c = this.state.map.get("C");
      const m = this.state.map.get("M");
      const y = this.state.map.get("Y");

      const r = Number.parseFloat(255 * (1 - c / 100) * (1 - k / 100)).toFixed(0);
      const g = Number.parseFloat(255 * (1 - m / 100) * (1 - k / 100)).toFixed(0);
      const b = Number.parseFloat(255 * (1 - y / 100) * (1 - k / 100)).toFixed(0);

      this.state.map.set("R", r);
      this.state.map.set("G", g);
      this.state.map.set("B", b);

      const w3c = w3color(`rgb(${r},${g},${b})`);

      const targetId = this.state.selectedRadioId.slice(0, -6); // left-background
      this.state.map.set(targetId + "-name", "无");
      this.state.map.set(targetId + "-hex", w3c.toHexString().toUpperCase());
      this.state.map.set(targetId + "-rgb", w3c.toRgbString().toUpperCase());
      this.state.map.set(targetId + "-cmyk", `cmyk(${c},${m},${y},${k})`);

    } else { //rgb
      const r = this.state.map.get("R");
      const g = this.state.map.get("G");
      const b = this.state.map.get("B");

      const r_ = r / 255;
      const g_ = g / 255
      const b_ = b / 255;

      const k_ = 1 - Math.max(r_, g_, b_);
      const c = Number.parseFloat((1 - r_ - k_) / (1 - k_) * 100).toFixed(0);
      const m = Number.parseFloat((1 - g_ - k_) / (1 - k_) * 100).toFixed(0);
      const y = Number.parseFloat((1 - b_ - k_) / (1 - k_) * 100).toFixed(0);
      const k = Number.parseFloat(k_).toFixed(0);

      this.state.map.set("C", c);
      this.state.map.set("M", m);
      this.state.map.set("Y", y);
      this.state.map.set("K", k);

      const w3c = w3color(`rgb(${r},${g},${b})`);

      const targetId = this.state.selectedRadioId.slice(0, -6); // left-background
      this.state.map.set(targetId + "-name", "无");
      this.state.map.set(targetId + "-hex", w3c.toHexString().toUpperCase());
      this.state.map.set(targetId + "-rgb", w3c.toRgbString().toUpperCase());
      this.state.map.set(targetId + "-cmyk", `cmyk(${c},${m},${y},${k})`);

    }

    this.setStateDirty("map");
  }

  updateFreeColor(e) {
    e = e || window.event;
    e.preventDefault();

    const w3c = w3color(e.srcElement.value);

    const targetId = this.state.selectedRadioId.slice(0, -6); // left-background
    this.state.map.set(targetId + "-name", "无");
    this.state.map.set(targetId + "-hex", w3c.toHexString().toUpperCase());
    this.state.map.set(targetId + "-rgb", w3c.toRgbString().toUpperCase());

    const rgb = w3c.toRgb();
    this.state.map.set("R", rgb.r);
    this.state.map.set("G", rgb.g);
    this.state.map.set("B", rgb.b);

    const r_ = rgb.r / 255, g_ = rgb.g / 255, b_ = rgb.b / 255;

    const k_ = 1 - Math.max(r_, g_, b_);
    const c = Number.parseFloat((1 - r_ - k_) / (1 - k_) * 100).toFixed(0);
    const m = Number.parseFloat((1 - g_ - k_) / (1 - k_) * 100).toFixed(0);
    const y = Number.parseFloat((1 - b_ - k_) / (1 - k_) * 100).toFixed(0);
    const k = Number.parseFloat(k_).toFixed(0);

    this.state.map.set("C", c);
    this.state.map.set("M", m);
    this.state.map.set("Y", y);
    this.state.map.set("K", k);

    this.state.map.set(targetId + "-cmyk", `cmyk(${c},${m},${y},${k})`);

    this.setStateDirty("map");
  }

  setText(e) {
    this.openDialog();
  }

  setTextToLeft(e) {
    this.state.textPosition = "left";
  }

  setTextToMiddle(e) {
    this.state.textPosition = "center";
  }

  setTextToRight(e) {
    this.state.textPosition = "right";
  }

  resetAll(e) {
    Object.assign(this.state, this.backup);
  }

  openDialog() {
    this.state.openTextDialog = true;
  }

  saveDialog() {
    this.state.openTextDialog = false;
    this.emit('close');

    this.state.leftMovableText = document.getElementById("left-text-input-panel-id").value;
  }
  closeDialog() {
    this.state.openTextDialog = false;
    this.emit('close');
  }

  copyHexToClipboard(hex, event) {
    const that = this;
    navigator.clipboard.writeText(hex).then(
      () => {
        /* clipboard successfully set */
        that.state.msg = "複製到剪貼板成功";
        that.handleOpen();
      },
      () => {
        /* clipboard write failed */
      },
    );
  }

  handleOpen() {
    this.state.openSnackBarDialog = true;
  }

  handleClose() {
    this.state.openSnackBarDialog = false;
    this.emit('close');
  }

  setBorder(value, e) {
    if (value === "show") {
      document.getElementById("border-hide-radio").checked = false;
      document.getElementById("border-show-radio").checked = true;
      this.state.map.set("left-movable-border-style", "1px solid #d3d3d3");
    } else {
      document.getElementById("border-show-radio").checked = false;
      document.getElementById("border-hide-radio").checked = true;
      this.state.map.set("left-movable-border-style", "0px");
    }
    this.setStateDirty("map");
  }

};


